/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_ChangeInputs */

const cs_ebr_conn_change = /** @type {(inputs: Ebr_Conn_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit adresu`)
};

const en_ebr_conn_change = /** @type {(inputs: Ebr_Conn_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change address`)
};

/**
* | output |
* | --- |
* | "Change address" |
*
* @param {Ebr_Conn_ChangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_change = /** @type {((inputs?: Ebr_Conn_ChangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_ChangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_change(inputs)
	return cs_ebr_conn_change(inputs)
});